import { Component } from '@angular/core';

@Component({
    selector: 'app-red-asterisk',
    templateUrl: './red-asterisk.component.html',
    styleUrls: ['./red-asterisk.component.scss'],
    standalone: true
})
export class RedAsteriskComponent {

}
